<template>
	<div class="input-quantity">
		<div>
			<div class="decrease" @click="handleChangeValue(false)">
				<i class="bi bi-dash"></i>
			</div>
		</div>

		<input
			type="text"
			class="quantity-value"
			:value="internalValue"
			@input="handleInput"
			@keydown="preventNonNumericInput"
		/>

		<div>
			<div class="increase" @click="handleChangeValue(true)">
				<i class="bi bi-plus"></i>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	model: {
		prop: 'value',
		event: 'input',
	},
	props: {
		value: {
			type: Number,
			default: 0,
		},
		min: {
			type: Number,
			default: null,
		},
		max: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			internalValue: this.value || 0,
		};
	},
	watch: {
		value(newVal) {
			this.internalValue = newVal;
		},
	},
	methods: {
		handleInput(event) {
			let value = parseInt(event.target.value);

			// eslint-disable-next-line no-restricted-globals
			if (isNaN(value)) {
				value = this.min !== null ? this.min : 0;
			}

			if (this.min !== null && value < this.min) value = this.min;
			if (this.max !== null && value > this.max) value = this.max;

			this.internalValue = value;
			this.$emit('input', value);
			event.target.value = value;
		},
		handleChangeValue(increased) {
			if (increased) {
				this.internalValue += 1;
				if (this.max !== null && this.internalValue > this.max) {
					this.internalValue = this.max;
				}
			} else {
				this.internalValue -= 1;
				if (this.min !== null && this.internalValue < this.min) {
					this.internalValue = this.min;
				}
			}
			this.$emit('input', this.internalValue);
		},
		preventNonNumericInput(event) {
			const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
			const isNumber = /[0-9]/.test(event.key);

			if (!isNumber && !allowedKeys.includes(event.key)) {
				event.preventDefault();
			}
		},
	},
};
</script>

<style scoped lang="scss">
.input-quantity {
	width: 100%;
	height: fit-content;
	display: flex;
	flex-direction: row;
}

.decrease,
.increase {
	width: 30px;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #e9ecef;
	cursor: pointer;
	color: #000000;
}

.decrease {
	border-radius: 6px 0 0 6px;
}

.increase {
	border-radius: 0 6px 6px 0;
}

.quantity-value {
	width: calc(100% - 60px);
	outline: none;
	border: none;
	font-size: 14px;
	padding: 4px;
	border-top: 1px solid #e9ecef;
	border-bottom: 1px solid #e9ecef;
	text-align: center;
}
</style>
